export default __webpack_public_path__ + "images/21_thumbnail.jpg";